import Vue from 'vue'
import PortalVue from 'portal-vue'
import Vuex from 'vuex'

import smoothscroll from 'smoothscroll-polyfill'

import { Project } from './channel.types'
import ProjectApp from './components/ProjectApp.vue'
import ChannelAPI from './API/ChannelAPI'

import { getQueryStringParams } from '@/common/utils/queryStringUtils'

import Vue2TouchEvents from 'vue2-touch-events'
import VTooltip from 'v-tooltip'
import { MdButton, MdContent, MdTabs } from 'vue-material/dist/components'

import 'vue-material/dist/vue-material.min.css'

import { getStore } from './store/store'

import './styles/project.less'
import getEnvVars from '@/common/utils/getEnvVars'
import initSentry from '@/common/utils/initSentry'
import main from '@/common/shared.main'
import VueRouter from 'vue-router'
import router from './router'
import App from './components/App.vue'
import { api } from './API/ChannelAPI'

const { API_HOST } = getEnvVars()

declare global {
  interface Document {
    msHidden: any
    webkitHidden: any
  }
}

declare global {
  interface Window {
    setEmbeddedActivityWindow: any
    embeddedActivityWindow: any
    getNumberOfActionsFromActivity: any
  }
}

window.setEmbeddedActivityWindow = embeddedActivityWindow => {
  window.embeddedActivityWindow = embeddedActivityWindow
}

window.getNumberOfActionsFromActivity = () => {
  return window.embeddedActivityWindow
    ? window.embeddedActivityWindow.getNumberOfActions()
    : 0
}

function initVue() {
  smoothscroll.polyfill()
  Vue.use(PortalVue)
  Vue.use(Vuex)
  Vue.use(VueRouter)
  Vue.use(Vue2TouchEvents)
  Vue.use(VTooltip)
  Vue.use(MdButton)
  Vue.use(MdContent)
  Vue.use(MdTabs)
}

function channel() {
  const { search, pathname } = window.location

  ChannelAPI.host = API_HOST

  return (project: Project = null) => {
    initVue()

    const store = getStore()

    api.setStoreRef(store)

    return new Vue({
      el: '#app',
      store,
      router,
      render: h => h(App),
    })
  }
}

initSentry('https://cb534e29db2a4282abc62ceb5059f843@sentry.io/1371050')
main()
window.main = channel()
